<div class="app-accordion">
    <ng-content></ng-content>
</div>